import React from 'react';
import { Card, Icon, Image, Label, Transition } from 'semantic-ui-react';

import Base from 'src/components/coreUI/Card/Base';
import company_default from 'src/assets/default_company.png';
import { BarChart, Calendar, Global } from 'src/components/icons';
import dayjs from 'src/libs/dayjs';
import { FULL_MONTH } from 'src/constants/app';

type Props = {
  onClick?: () => void;
  company: Model.Company;
};

export default class Company extends Base<Props> {
  render() {
    const { onClick, company } = this.props;

    return (
      <Transition animation="fade down" transitionOnMount duration={500}>
        <Card onClick={onClick} fluid className="p-18">
          <div className="d-flex align-center justify-between flex-wrap gap-16">
            <div className="flex-shrink-0">
              <div className="d-flex align-center">
                <Image
                  width={48}
                  height={48}
                  circular
                  className="object-fit-cover flex-shrink-0"
                  src={company.logo || company_default}
                />
              </div>
            </div>

            <Card.Content className="flex-1">
              <Card.Header className="mb-8 fs-22">{company.name}</Card.Header>

              <Card.Description className="d-flex align-center mb-4">
                <Global />:
                <a
                  className="ml-4 text-primary"
                  href={company.website}
                  target="_blank"
                  rel="noreferrer"
                >
                  {company.domain}
                </a>
              </Card.Description>

              <Card.Description className="d-flex align-center mb-4">
                <BarChart />:
                <Label.Group className="ml-4">
                  {company.industries?.map((industry, index) => (
                    <Label key={index}>{industry}</Label>
                  ))}
                </Label.Group>
              </Card.Description>

              <div className="d-flex gap-16">
                <Card.Description className="d-flex align-center mb-4">
                  <Calendar />:
                  <span className="ml-4">
                    {dayjs(company.created_at).format(FULL_MONTH)}
                  </span>
                </Card.Description>

                {company.linkedin && (
                  <Card.Description className="d-flex align-center mb-4">
                    <a
                      className=""
                      href={company.linkedin}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Icon name="linkedin" color="blue" className="mb-6" />
                      {company.linkedin_username}
                    </a>
                  </Card.Description>
                )}
              </div>
            </Card.Content>
          </div>
        </Card>
      </Transition>
    );
  }
}
